import { onReady } from "../../utils/events/onReady";
//this js file is not in use - api request is handled in the cshtml file
export class LeqembiCalculator {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init(domReference));
    }

    init(domReference) {
        domReference
            .querySelector("#weight")
            .addEventListener("input", function(event) {
                let input = event.target;
                let value = input.value;

                // Regex to match a number with up to one optional decimal place
                const regex = /^\d*\.?\d{0,1}$/;

                if (!regex.test(value)) {
                    // If the input is invalid, revert to the last valid value
                    input.value = input.getAttribute("data-last-valid") || "";
                } else {
                    // Otherwise, store the current value as the last valid one
                    input.setAttribute("data-last-valid", value);
                }
            });
    }
}
